<!--企业简介-->
<template>
  <div class="productDetail_wrap" v-loading="loading">
    <!-- 用v-html渲染富文本，替代手动DOM操作 -->
    <div class="productDetail_item" v-html="richTextContent"></div>
  </div>
</template>

<script>

import {getGroupInfo} from "@/api/home";

export default {
  name: "CompanyProfile",
  data() {
    return {
      loading: false,
      richTextContent: "", // 存储过滤后的富文本内容
    };
  },
  created() {
    this.getGroupInfo();
  },
  methods: {
    async getGroupInfo() {
      try {
        this.loading = true;
        const type = 'company_profile';
        const res = await getGroupInfo(type);

        if (res.code === 200) {
          // 兼容不同接口返回字段（如果字段名不同，可在这里统一处理）
          this.richTextContent = res.data[0].richText || "";
        } else {
          this.$message.error(res.msg);
          this.richTextContent = "";
        }
      } catch (error) {
        this.$message.error("网络异常，请稍后重试");
        this.richTextContent = "";
      } finally {
        this.loading = false;
      }
    },
  }
}
</script>

<style scoped lang="scss">
html,
body {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}

.productDetail_wrap {
  //width: 90%;
  height: 100%;
  margin: 0 auto;
  :deep(.productDetail_item) {
    margin-top: 100px;
    width: 100%;
    height: 100%;
    box-sizing: border-box;

    p {
      img {
        width: 100% !important;
        height: auto;
        margin: 0 auto;
      }
    }

    table,
    .rich-text-container,
    iframe {
      margin: 0 auto;
      max-width: 100%;
    }
    img,
    video {
      height: auto;
    }
  }
}
</style>